import { Link } from "react-router-dom";
import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { addPrime, checkNomPrime } from '../../../../services/RHService/PrimeService';
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";

const Addprime = () => {
    const [nomprimeError, setNomprimeError] = useState('');
    const [nomPrime, setNomPrime] = useState("");
    const [iscotisable, setIscotisable] = useState(false);
    const [isimposable, setIsimposable] = useState(false);
    const [fct_presence, setFct_presence] = useState(false);
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(600);

    const handleMinPriceChange = (event) => {
        setMin(event.target.value);
    };
    const handleMaxPriceChange = (event) => {
        setMax(event.target.value);
    };
    // const [formData, setFormData] = useState({
    //     nomPrime: "",
    //     iscotisable: false,
    //     isimposable: false,
    //     fct_presence: false,
    //     min: 0,
    //     max: 600
    // });
    const priceRange = `${min}-${max}`;
    const handleIsCotisableChange = (event) => {
        if (event.target.checked) {
            setIscotisable(true);
        } else {
            setIscotisable(false);

        }

    }
    const handleIsImposableChange = (event) => {
        if (event.target.checked) {
            setIsimposable(true);
        } else {
            setIsimposable(false);

        }

    }
    const handleFctPresenceChange = (event) => {
        if (event.target.checked) {
            setFct_presence(true);
        } else {
            setFct_presence(false);

        }

    }
    const onChangeNomPrimeHandler = (event) => {
        setNomPrime(event.target.value);
    };
    // const handleInputChange = (event) => {
    //     const target = event.target;
    //     const name = target.name;
    //     const value = target.type === 'checkbox' ? target.checked : target.value;
    //     if (name === "iscotisable" && value) {
    //         formData.iscotisable = true;
    //     }
    //     else if (name === "isimposable" && value) {
    //         formData.isimposable = true;
    //     } else if (name === "fct_presence" && value) {
    //         formData.fct_presence = true;
    //     }
    //     else {
    //         setFormData({
    //             ...formData, [name]: target.value
    //         });
    //     }
    // }
    const handleSubmit = (event) => {
        event.preventDefault();

        let formData = {
            idUserCreation: getCurrentUserId(),
            nomPrime: nomPrime,
            min: min,
            max: max,
            iscotisable: iscotisable,
            isimposable: isimposable,
            fct_presence: fct_presence,
        }

        checkNomPrime(nomPrime, getCurrentUserId()).then((response) => {
            if (response.data.success === false) {
                addPrime(formData).then((res) => {
                    console.log("addPrime", res);
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: 'Prime inséré avec succès',
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }).catch((error) => {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: "Une erreur s'est produite lors de l'insertion",
                    });
                })
            }
        })
    };
    return (
        <section className="content-wrapper" style={{ marginTop: "0" }}>
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">  Ajouter une prime</h1>
                        </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item"><i class="fa-solid fa-house"></i></li>
                                <li className="breadcrumb-item"><Link to="/" style={{ color: "black" }}>Home</Link></li>
                                <li className="breadcrumb-item active"><Link to="/primelist" style={{ color: "black" }}>Liste des primes</Link></li>
                                <li className="breadcrumb-item active">Ajouter une prime</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-dark">
                                <div class="card-header">
                                    <h4 class="card-title">Ajouter une prime</h4>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card-body">
                                                {/* <div className="form-group">
                                                    <label for="exampleInputPassword1">Prime</label>
                                                    <input type="text" className="form-control form-control-border" onChange={handleInputChange} name="nomPrime" placeholder="Prime" />
                                                </div> */}
                                                <div className="form-group">
                                                    <label htmlFor="inputName">Prime</label>
                                                    <input
                                                        placeholder="Ajouter libellé "
                                                        onChange={onChangeNomPrimeHandler}
                                                        type="text"
                                                        id="inputName"
                                                        className="form-control"
                                                    />
                                                </div>
                                                {nomprimeError && <p style={{ color: 'red' }}>{nomprimeError}</p>}

                                                <div className="form-group">
                                                    <label for="exampleInputPassword1">Rang de montant :</label>
                                                    <input
                                                        class="custom-range custom-range-dark"
                                                        type="range"
                                                        name="min"
                                                        min="0"
                                                        max="300"
                                                        value={min}
                                                        onChange={handleMinPriceChange}
                                                    />
                                                    <input
                                                        class="custom-range custom-range-dark"
                                                        type="range"
                                                        name="max"
                                                        min="300"
                                                        max="600"
                                                        value={max}
                                                        onChange={handleMaxPriceChange}
                                                    />


                                                    <label>    Le rang de montant est :  </label>  {min}DT - {max}DT

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>
                                                        Cotisable
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Imposable
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        Fonction de présence
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="card-body">
                                                <div className="form-group">
                                                    <label>
                                                        <input type="checkbox" name="iscotisable" value={iscotisable} onChange={handleIsCotisableChange} />
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        <input type="checkbox" name="isimposable" value={isimposable} onChange={handleIsImposableChange} />
                                                    </label>
                                                </div>
                                                <div className="form-group">
                                                    <label>
                                                        <input type="checkbox" name="fct_presence" value={fct_presence} onChange={handleFctPresenceChange} />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-dark col-md-3 float-right" style={{ "width": "auto" }}>Confirmer</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
}
export default Addprime;